import { useAccount, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useUserPermission } from "@helpers/userPermissionHelper";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../app/hooks";
import { getClaims } from "../helpers/claimHelper";
import { updateAccounts, updateIsUserLoggedIn, updateUserClaims } from "../store/userAccountSlice";
import TrackPageView from "./trackPageViews";

export const UserAccountClaims = (): JSX.Element | null => {
    const { accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const isUserLoggedIn = useIsAuthenticated();
    const userClaims = getClaims(accounts);

    const dispatch = useDispatch();

    const accountInfo = useAppSelector((state) => state.account);
    const { userRoles } = useUserPermission({ useCurrentLocation: true });
    const { trackPageViewFunction } = TrackPageView(location.pathname, accountInfo, userRoles);

    // store user account in redux
    // triggers when: account changes, redux reset notification is sent, or page changes
    useEffect(() => {
        if (isUserLoggedIn !== accountInfo.isUserLoggedIn) {
            dispatch(updateIsUserLoggedIn(isUserLoggedIn));
        }
        if (accountInfo.accounts.length !== accounts.length) {
            dispatch(updateAccounts(accounts));
        }
        if (accountInfo.claims !== userClaims) {
            dispatch(updateUserClaims(userClaims));
        }
    }, [account]);

    // track page view
    useEffect(() => {
        trackPageViewFunction();
    }, [location.pathname, account]);

    return null;
};
